import {
Component,
Injector,
Optional
} from '@angular/core';
import {CommonModule} from "@angular/common";

import { DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, register, styler, getImageUrl } from "@wm/components-base";

const DEFAULT_CLS = 'app-video';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-video',
  hostClass: DEFAULT_CLS,
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};

@Component({
  selector: '[wmVideo]',
  template: `<video [preload]="videopreload" role="application"
                    [src]="mp4format "
                    [muted]="muted"
                    [poster]="_posterUrl "
                    [controls]="controls"
                    [loop]="loop"
                    [autoplay]="autoplay">
    <source type="video/mp4" [src]="mp4format " *ngIf="mp4format">
    <source type="video/webm" [src]="webmformat " *ngIf="webmformat">
    <source type="video/ogg" [src]="oggformat " *ngIf="oggformat">
    {{videosupportmessage}}
  </video>`,
  providers: [
    provideAsWidgetRef(VideoComponent)
  ],
  exportAs: 'wmVideo',
  standalone: true,
  imports: [ CommonModule ],
  styles: []
})
export class VideoComponent extends StylableComponent {
  static initializeProps = register('wm-video');

  public subtitlelang = 'en';
  public videopreload: any;
  public mp4format: string;
  public muted: boolean;
  public videoposter: any;
  public controls: boolean;
  public loop: boolean;
  public autoplay: boolean;
  public webmformat: string;
  public oggformat: string;
  public videosupportmessage: any;
  _posterUrl: any;

  constructor(inj: Injector,
              @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
  }
  protected override onPropertyChange(key: string, nv: any, ov?: any) {
    if(key === 'videoposter'){
      this.videoposter = nv ? nv : getImageUrl(nv); // url without full project path, to show in properties panel
      this._posterUrl = getImageUrl(nv); // actual resource path
    }
    super.onPropertyChange(key, nv, ov);
  }

}

